// Prevents the MZ player and Google IMA from initializing before the visitor has made a cookie choice.
const waitForMzCookieConsent = () => {
	if (!window.isMz) return Promise.resolve();

	return new Promise((resolve) => {
		let wasResolved = false;
		let consentStatusInterval = null;
		let consentListenerWasRegistered = false;
		const resolveConsent = () => {
			if (wasResolved) return;

			wasResolved = true;
			clearInterval(consentStatusInterval);
			resolve();

			if (!consentListenerWasRegistered) return;
			try {
				window.__cmp('removeEventListener', ['consent', handleConsent, false], null);
			} catch (error) {
				console.warn('Unable to remove MZ cookie consent listener', error);
			}
		};
		const handleConsent = () => resolveConsent();
		const checkConsentStatus = () => {
			try {
				const consentStatus = window.__cmp('consentStatus', null, null, false);
				if (consentStatus?.userChoiceExists) resolveConsent();
			} catch {
				// The injected CMP stub can temporarily reject commands while the full CMP is loading.
			}
		};

		try {
			consentListenerWasRegistered = true;
			window.__cmp('addEventListener', ['consent', handleConsent, false], null);
		} catch (error) {
			consentListenerWasRegistered = false;
			console.warn('Unable to register MZ cookie consent listener', error);
		}

		if (wasResolved) return;
		consentStatusInterval = setInterval(checkConsentStatus, 250);
		checkConsentStatus();
	});
};

export { waitForMzCookieConsent };
